import { Home, Briefcase, UtensilsCrossed, HeartHandshake, Palette, ShoppingBag, LayoutGrid } from "lucide-react";

// Curated Collections — the customer-facing browsing vocabulary. Each maps one or
// more raw DB categories into a themed group. Anything unmapped falls into "More Designs".
// Single source of truth so the Marketplace filter, cards and detail page all agree
// (and we never surface raw internal category names to clients).
export const COLLECTIONS = [
  { key: "home-services", label: "Home Services", Icon: Home, blurb: "Contractors & local trades", cats: ["Construction", "Contractors", "Small Business"] },
  { key: "professional", label: "Professional Services", Icon: Briefcase, blurb: "Experts, advisors & practices", cats: ["Legal", "Healthcare", "Medical", "Coaching", "Coaches", "Author", "Authors", "Business", "Personal Brands"] },
  { key: "hospitality", label: "Hospitality & Personal Care", Icon: UtensilsCrossed, blurb: "Dining, beauty & guest experiences", cats: ["Restaurants", "Grooming & Beauty"] },
  { key: "mission", label: "Mission & Community", Icon: HeartHandshake, blurb: "Faith, nonprofits & causes", cats: ["Church & Ministry", "Churches", "Ministries", "Nonprofit", "Nonprofits", "Veterans"] },
  { key: "creative", label: "Creative", Icon: Palette, blurb: "Portfolios & creative brands", cats: ["Portfolio"] },
  { key: "retail", label: "Retail & Store", Icon: ShoppingBag, blurb: "E-commerce & product sales", cats: ["Ecommerce"] },
];

export const MORE_COLLECTION = { key: "more", label: "More Designs", Icon: LayoutGrid, blurb: "Additional designs" };

export const CAT_TO_COLLECTION = COLLECTIONS.reduce((m, c) => { c.cats.forEach((cat) => { m[cat] = c.key; }); return m; }, {});

// Customer-facing label for a raw DB category — always a collection label, never the raw category.
export function collectionLabel(category) {
  const key = CAT_TO_COLLECTION[category] || "more";
  const c = COLLECTIONS.find((x) => x.key === key);
  return c ? c.label : MORE_COLLECTION.label;
}
